<template>
  <label
    class="vs-component con-vs-radio"
    :class="[`vs-radio-${color}`, $attrs.class]"
    :style="$attrs.style"
  >
    <input
      class="vs-radio--input"
      :name="vsName || currentValue"
      type="radio"
      :checked="isChecked"
      :value="currentValue"
      v-bind="inputAttrs"
      @input="selectValue"
      @click="selectValue"
    />
    <span class="vs-radio">
      <span class="vs-radio--borde" :style="borderStyle" />
      <span class="vs-radio--circle" :style="circleStyle" />
    </span>
    <span class="vs-radio--label"><slot /></span>
  </label>
</template>

<script>
export default {
  name: "VsRadio",
  inheritAttrs: false,
  props: {
    modelValue: {
      default: undefined,
    },
    value: {
      default: undefined,
    },
    vsValue: {
      default: undefined,
    },
    vsName: {
      default: undefined,
    },
    color: {
      type: String,
      default: "primary",
    },
  },
  emits: ["update:modelValue", "input"],
  computed: {
    currentValue() {
      return this.modelValue !== undefined ? this.modelValue : this.value;
    },
    isChecked() {
      // Vuesax intentionally allows numeric and string identifiers to match.
      // eslint-disable-next-line eqeqeq
      return this.vsValue == this.currentValue;
    },
    resolvedColor() {
      if (
        this.color.startsWith("#") ||
        this.color.startsWith("rgb") ||
        this.color.startsWith("hsl") ||
        this.color.startsWith("var(")
      ) {
        return this.color;
      }
      return `rgba(var(--vs-${this.color}), 1)`;
    },
    borderStyle() {
      return {
        border: `2px solid ${
          this.isChecked ? this.resolvedColor : "rgb(200, 200, 200)"
        }`,
      };
    },
    circleStyle() {
      return {
        background: this.resolvedColor,
        boxShadow: `0px 3px 12px 0px ${this.resolvedColor.replace(
          /,\s*1\)$/,
          ", .4)"
        )}`,
      };
    },
    inputAttrs() {
      const attrs = { ...this.$attrs };
      ["class", "style", "onInput", "onClick"].forEach(
        (key) => delete attrs[key]
      );
      return attrs;
    },
  },
  methods: {
    selectValue() {
      this.$emit("update:modelValue", this.vsValue);
      this.$emit("input", this.vsValue);
    },
  },
};
</script>
